import React from 'react';
import { Badge } from '../../../components/ui/badge';
import { Checkbox } from '../../../components/ui/checkbox';
import { Paperclip, Clock } from 'lucide-react';
import { ResponsableChip } from './CRMResponsable';

const fmtDemora = (m) => (m >= 60 ? `${Math.floor(m / 60)} h${m % 60 ? ` ${m % 60} min` : ''}` : `${m} min`);

export const CRMContactoItem = ({ c, meta, active, seleccionando, seleccionado, onToggle, onOpen, fecha }) => {
  const unread = c.no_leidos > 0;
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => (seleccionando ? onToggle(c.phone) : onOpen(c.phone))}
      onKeyDown={(e) => e.key === 'Enter' && (seleccionando ? onToggle(c.phone) : onOpen(c.phone))}
      className={`w-full text-left px-3 py-2.5 border-b cursor-pointer flex gap-2 transition-colors hover:bg-amber-50 ${active ? 'bg-amber-100' : ''} ${seleccionado ? 'bg-emerald-50' : ''}`}
      data-testid={`crm-contacto-${c.phone}`}
    >
      {seleccionando && (
        <Checkbox checked={seleccionado} onClick={e => { e.stopPropagation(); onToggle(c.phone); }}
          className="mt-1 shrink-0" data-testid={`crm-check-${c.phone}`} />
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <span className={`text-sm truncate ${unread ? 'font-bold text-gray-900' : 'font-medium'}`}>{c.nombre || c.phone}</span>
          <div className="flex items-center gap-1 shrink-0">
            <ResponsableChip responsable={c.responsable} />
            <Badge className={`${meta.color} text-xs`}>{meta.label}</Badge>
          </div>
        </div>
        {c.nombre && <p className="text-xs text-gray-500 font-mono">{c.phone}</p>}
        <div className="flex items-end justify-between gap-2 mt-1">
          <p className={`text-xs line-clamp-2 ${unread ? 'font-semibold text-gray-900' : 'text-gray-600'}`}>
            {c.ultimo_mensaje || <em className="text-gray-400">sin mensajes</em>}
          </p>
          {c.demorada && (
            <span className="shrink-0 h-5 px-1.5 rounded-full bg-red-600 text-white text-[11px] font-bold flex items-center gap-0.5 animate-pulse"
              title="Esperando sin atender (minutos en horario de atención)" data-testid={`crm-demora-${c.phone}`}>
              <Clock className="w-3 h-3" />Esperando hace {fmtDemora(c.demora_min)}
            </span>
          )}
          {c.archivos_pendientes > 0 && (
            <span className="shrink-0 h-5 px-1.5 rounded-full bg-orange-500 text-white text-[11px] font-bold flex items-center gap-0.5"
              title="Archivos pendientes de revisión" data-testid={`crm-archivos-pend-${c.phone}`}>
              <Paperclip className="w-3 h-3" />{c.archivos_pendientes}
            </span>
          )}
          {unread && (
            <span className="shrink-0 min-w-[20px] h-5 px-1.5 rounded-full bg-emerald-500 text-white text-[11px] font-bold flex items-center justify-center"
              data-testid={`crm-no-leidos-${c.phone}`}>
              {c.no_leidos}
            </span>
          )}
        </div>
        <p className={`text-[10px] mt-1 ${unread ? 'text-emerald-600 font-semibold' : 'text-gray-400'}`}>{fecha}</p>
      </div>
    </div>
  );
};
